import {
  FETCH_MOST_ACCESSED_MENUS_REQUEST,
  FETCH_MOST_ACCESSED_MENUS_REQUEST_NEW,
  FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB,
  FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE,
  FETCH_MOST_ACCESSED_MENUS_ERROR,
  FETCH_DEVICES_UPDATE_REQUEST,
  FETCH_DEVICES_UPDATE_SUCCESS,
  FETCH_DEVICES_UPDATE_ERROR,
  FETCH_ACTIVE_INACTIVE_USERS_REQUEST,
  FETCH_ACTIVE_INACTIVE_USERS_SUCCESS,
  FETCH_ACTIVE_INACTIVE_USERS_ERROR,
  FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_REQUEST,
  FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_SUCCESS,
  FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_ERROR,
  FETCH_LIST_MOST_ACCESSED_MENUS_WEB_REQUEST,
  FETCH_LIST_MOST_ACCESSED_MENUS_WEB_SUCCESS,
  FETCH_LIST_MOST_ACCESSED_MENUS_WEB_ERROR,
  FETCH_FUNCIONALITIES_DETAILS_SUCCESS,
  FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB_V2,
  FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE_V2,

  FETCH_FILTERS_GLOBAL_SUCCESS
} from 'actionTypes'


const DEFAULT_STATE = {
  menusMobile: {
    record: [],
    error: null,
    isFetching: false,
  },
  menusWeb: {
    record: [],
    error: null,
    isFetching: false,
  },
  devices: {
    record: {},
    error: null,
    isFetching: false,
  },
  users: {
    record: {},
    error: null,
    isFetching: false,
  },
  listMobile: {
    record: {},
    error: null,
    isFetching: false,
  },
  listWeb: {
    record: {},
    error: null,
    isFetching: false,
  },
  listMostAccess: {
    record: {},
    error: null,
    isFetching: false
  },

  listFuncionalitiesDetails: {
    record: {},
    error: null,
    isFetching: false
  },

  listRelatoryDetails: {
    record: {},
    error: null,
    isFetching: false
  },
  listFiltersGlobal: {
    record: {}
  },
  funcionalityMostAccess: {
    record: {},
    error: null,
    isFetching: false
  },
  relatoriesWebMostAccess: {
    record: {},
    error: null,
    isFetching: false
  }
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {

    case FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB_V2:
      return {
        ...state,
        relatoriesWebMostAccess: {
          ...state.relatoriesWebMostAccess,
          record: action.payload
        },
      }


    case FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE_V2:
      return {
        ...state,
        funcionalityMostAccess: {
          ...state.funcionalityMostAccess,
          record: action.payload
        },
      }

    case FETCH_MOST_ACCESSED_MENUS_REQUEST_NEW:
      return {
        ...state,
        listMostAccess: {
          ...state.listMostAccess,
          isFetching: true,
          record: action.payload
        },
      }

    case FETCH_FILTERS_GLOBAL_SUCCESS:
      return {
        ...state,
        listFiltersGlobal: {
          ...state.listFiltersGlobal,
          record: action.payload
        }
      }

    case FETCH_MOST_ACCESSED_MENUS_REQUEST:
      return {
        ...state,
        menus: {
          ...state.menus,
          isFetching: true,
        },
      }

    case FETCH_MOST_ACCESSED_MENUS_SUCCESS_MOBILE:
      return {
        ...state,
        menusMobile: {
          ...state.menusMobile,
          isFetching: false,
          error: null,
          record: action.payload,
        },
      }

    case FETCH_MOST_ACCESSED_MENUS_SUCCESS_WEB:
      return {
        ...state,
        menusWeb: {
          ...state.menusWeb,
          isFetching: false,
          error: null,
          record: action.payload,
        },
      }

    case FETCH_MOST_ACCESSED_MENUS_ERROR:
      return {
        ...state,
        menus: {
          ...state.menus,
          isFetching: false,
          record: [],
          error: action.payload,
        },
      }

    case FETCH_DEVICES_UPDATE_REQUEST:
      return {
        ...state,
        devices: {
          ...state.devices,
          isFetching: true,
        },
      }

    case FETCH_DEVICES_UPDATE_SUCCESS:
      return {
        ...state,
        devices: {
          ...state.devices,
          isFetching: false,
          error: null,
          record: action.payload,
        },
      }

    case FETCH_DEVICES_UPDATE_ERROR:
      return {
        ...state,
        devices: {
          ...state.devices,
          isFetching: false,
          record: {},
          error: action.payload,
        },
      }

    case FETCH_ACTIVE_INACTIVE_USERS_REQUEST:
      return {
        ...state,
        users: {
          ...state.users,
          isFetching: true,
        },
      }

    case FETCH_ACTIVE_INACTIVE_USERS_SUCCESS:
      return {
        ...state,
        users: {
          ...state.users,
          isFetching: false,
          error: null,
          record: action.payload,
        },
      }

    case FETCH_ACTIVE_INACTIVE_USERS_ERROR:
      return {
        ...state,
        users: {
          ...state.users,
          isFetching: false,
          record: {},
          error: action.payload,
        },
      }

    case FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_REQUEST:
      return {
        ...state,
        listMobile: {
          ...state.listMobile,
          isFetching: true,
        },
      }

    case FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_SUCCESS:
      return {
        ...state,
        listMobile: {
          ...state.listMobile,
          isFetching: false,
          error: null,
          record: action.payload,
        },
      }

    case FETCH_LIST_MOST_ACCESSED_MENUS_MOBILE_ERROR:
      return {
        ...state,
        listMobile: {
          ...state.listMobile,
          isFetching: false,
          record: [],
          error: action.payload,
        },
      }

    case FETCH_LIST_MOST_ACCESSED_MENUS_WEB_REQUEST:
      return {
        ...state,
        listWeb: {
          ...state.listWeb,
          isFetching: true,
        },
      }

    case FETCH_LIST_MOST_ACCESSED_MENUS_WEB_SUCCESS:
      return {
        ...state,
        listWeb: {
          ...state.listWeb,
          isFetching: false,
          error: null,
          record: action.payload,
        },
      }

    case FETCH_LIST_MOST_ACCESSED_MENUS_WEB_ERROR:
      return {
        ...state,
        listWeb: {
          ...state.listWeb,
          isFetching: false,
          record: [],
          error: action.payload,
        },
      }

      case FETCH_FUNCIONALITIES_DETAILS_SUCCESS:
        return {
          ...state,
          listFuncionalitiesDetails: {
            ...state.listFuncionalitiesDetails,
            isFetching: false,
            error: null,
            record: action.payload
          },
        }

    default:
      return state
  }
}

export default record
